import React from 'react';

export interface CenteredInputProps {
  label?: string;
  id: string;
  name: string;
  type: string;
  placeholder: string;
  setValue?: React.Dispatch<React.SetStateAction<string | any>>;
  defaultValue?: string;
  disabled?: boolean;
  value?: string;
  className?: string;
  button?: {
    text: string;
    onClick: () => void | Promise<void>;
    disabled?: boolean;
    cancelText?: string;
    cancelClick?: () => void | Promise<void>;
  };
}

export const CenteredInput = (props: CenteredInputProps) => {
  return (
    <div>
      <div className="relative">
        <input
          disabled={props.disabled}
          id={props.id}
          name={props.name}
          type={props.type}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          value={props.value}
          onChange={(event) => {
            if (props.setValue) {
              props.setValue(event.target.value);
            }
          }}
          className={`block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2
              focus:-outline-offset-2 focus:outline-indigo-600 disabled:bg-transparent
              disabled:text-gray-500 disabled:outline-gray-200 sm:text-sm/6 text-center ${
    props.className ?? ''
    }`}
        />
        {props.button && (
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-[calc(100%+0.75rem)] flex space-x-2">
            <button
              type="button"
              disabled={props.button.disabled}
              onClick={props.button.onClick}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm
                  hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                  focus-visible:outline-indigo-600"
            >
              {props.button.text}
            </button>
            {props.button.cancelText && (
              <button
                type="button"
                className="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm
                      hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                      focus-visible:outline-gray-600"
                onClick={props.button.cancelClick}
              >
                {props.button.cancelText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
